import React, { useEffect, useState } from "react";
import {
  Table,
  Select,
  DatePicker,
  Button,
  Checkbox,
  Tag,
  Card,
  Layout,
} from "antd";
import {
  ArrowLeftOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { list } from "../upload/Uploads";
import "./auditlogs.css";
import HeaderCompo from "../../../component/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../utils/axiosInterceptor";

const { Option } = Select;
const { RangePicker } = DatePicker;

const AuditLogs = () => {
  const location = useLocation();
  const { data } = location.state || {};
  const {from} = location.state || {}
    const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Data Review");
  const [fileType, setFileType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRebateData,setSelectedRebateData] = useState([])
  const [selectedCogsData,setSelectedCogsData] = useState([])


  const columns = [
    {
      title: "Account Number",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      key: "accountName",
    },

    {
      title: "GCR Ratio",
      dataIndex: "gcrPer",
      key: "gcrPer",
    },
    
    {
      title: "SGCR Ratio",
      dataIndex: "sgcrPer",
      key: "sgcrPer",
    },
    
    {
      title: "GPR Ratio",
      dataIndex: "gprPer",
      key: "gprPer",
    },
    
    {
      title: "Exception Reason",
      dataIndex: "exceptionReason",
      key: "exceptionReason",
    },      
{
  title: "Action",
  dataIndex: "status",
  key: "status",
  render: (status, record) => {
    if (status === "Rejected") {
      return <Tag color="red">Rejected</Tag>;
    } else if (status === "Approved") {
      return <Tag color="green">Approved</Tag>;
    } else if (status === "Pending" || status === "Uploaded") {
      return (
        <div className="flex gap-2">
          <Button
            type="primary"
            size="small"
            onClick={() => handleApprove(record)}
          >
            Approve
          </Button>
          <Button
            danger
            size="small"
            onClick={() => handleReject(record)}
          >
            Reject
          </Button>
        </div>
      );
    } else {
      return <Tag color="default">{status || "Unknown"}</Tag>;
    }
  },
}

  ];

  const cogsColumn = [
    {
      title: "FileI ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Account Id",
      dataIndex: "ACCT_ID",
      key: "ACCT_ID",
    },

    {
      title: "Lock ID",
      dataIndex: "LockID",
      key: "LockID",
       render: (value) => value === null || value === undefined ? "null" : value
    },
    
    {
      title: "CUR BRX File",
      dataIndex: "CUR_BRX_File",
      key: "CUR_BRX_File",
    },
    
    {
      title: "CUR BRX DB",
      dataIndex: "CUR_BRX_DB",
      key: "CUR_BRX_DB",
    },
    
    {
      title: "COG File",
      dataIndex: "COG_File",
      key: "COG_File",
    },    
      
    {
      title: "COG DB",
      dataIndex: "COG_DB",
      key: "COG_DB",
    },      
      
    {
      title: "GCR File",
      dataIndex: "GCR_File",
      key: "GCR_File",
    },    
      
    {
      title: "GCR DB",
      dataIndex: "GCR_DB",
      key: "GCR_DB",
    },    
      
    {
      title: "Reasons",
      dataIndex: "ErrorReasons",
      key: "ErrorReasons",
    },    
{
  title: "Action",
  dataIndex: "Status",
  key: "action",
  render: (status, record) => {
    if (status === "Rejected") {
      return <Tag color="red">Rejected</Tag>;
    } else if (status === "Approved") {
      return <Tag color="green">Approved</Tag>;
    } else if (status === "Pending" || status === "Uploaded") {
      return (
        <div className="flex gap-2">
          <Button
            type="primary"
            size="small"
            onClick={() => handleApproveCogs(record)}
          >
            Approve
          </Button>
          <Button
            danger
            size="small"
            onClick={() => handleRejectCogs(record)}
          >
            Reject
          </Button>
        </div>
      );
    } else {
      return <Tag color="default">{status || "Unknown"}</Tag>;
    }
  },
}

  ];

const handleApproveCogs = async(record)=>{
     if(!record?.FileId){
      return;
     }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/exceptionCOGS/${record?.FileId}/${record?.ACCT_ID}/approve`);
      getSelectedCogsData()
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
    }
}
const handleRejectCogs = async(record)=>{
  if(!record?.FileId){
      return;
     }
     const payload = {
      reason : record?.ErrorReasons
     }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/exceptionCOGS/${record?.FileId}/${record?.AccountId}/reject`,payload);
      getSelectedCogsData()
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
    }
}

  const handleApprove = async(record)=>{
     if(!record?.Id){
      return;
     }
     const payload = {
      reason : record?.exceptionReason
     }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/rebate-exceptions/approve/${record?.Id}`,payload);
      getFileDetails()
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
    }
  }

  const handleReject = async(record)=>{
     if(!record?.Id){
      return;
     }
     const payload = {
      reason : record?.exceptionReason
     }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/rebate-exceptions/reject/${record?.Id}`,payload);
      getFileDetails()
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
    }
  }

  useEffect(() => {
    if(from === "cogs"){
      getSelectedCogsData()
    }else{
      getFileDetails();
    }
  }, [data]);

  const getFileDetails = async () => {
    if (!data?.Id) {
      return;
    }
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `/automationRouter/rebate-exceptions/${data?.Id}`
      );
      setSelectedRebateData(response?.data)
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setLoading(false);
    }
  };

   const getSelectedCogsData = async () => {
    if (!data?.Id) {
      return;
    }
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `/automationRouter/exceptionsCOGS/${data?.Id}`
      );
      setSelectedCogsData(response?.data?.exceptions)
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  const tabs = ["Data Review", "Audit Logs", "Reports"];

  return (
    // <Layout className="bg-gray-50 min-h-screen">
    <div className="h-screen ">
      <div className="fixed top-0 left-0 right-0 z-50">
        <HeaderCompo initialColor={"#000833"} />
      </div>
      <Layout className="pt-[80px]  overflow-y-auto bg-gray-50">
        <div className="mb-6">
      <Button
        type="text"
        icon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
        onClick={() => navigate('/automation-dashboard',{state:{menu : "approvals"}})} // go back to previous page
        style={{
          // position: "absolute",
          top: 10,
          left: 10,
          zIndex: 10,
        }}
      />
        </div>


        <Card
          className="rounded-xl shadow-sm border"
          title={
            <div className="flex justify-between items-center overflow-auto scrollbar-hide">
              {/* Tabs Section */}
              <div className="flex items-center space-x-8 border-b border-gray-200">
                {tabs.map((tab) => (
                  <div
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`relative cursor-pointer px-2 pb-3 text-[15px] font-medium transition-all duration-200 
                    ${
                      activeTab === tab
                        ? "text-[#000833]"
                        : "text-gray-500 hover:text-[#000833]"
                    }`}
                  >
                    {tab}
                    {activeTab === tab && (
                      <span className="absolute bottom-0 left-0 w-full h-[2px] bg-[#000833] rounded-full"></span>
                    )}
                  </div>
                ))}
              </div>

              {/* Icons Section */}
              <div className="flex items-center gap-4 ml-20">
                <InfoCircleOutlined className="text-gray-500 text-[16px]" />
                <MoreOutlined className="text-gray-500 text-[18px]" />
              </div>
            </div>
          }
          
        >
          {activeTab === "Data Review" && (
            <>
              <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <h2 className="text-lg font-semibold">
                  Audit Comparison
                </h2>
              </div>

             {
              from == "cogs" ? 
               <Table
                columns={cogsColumn}
                dataSource={selectedCogsData}
                loading={loading}
                bordered
                pagination={false}
                scroll={{ x: "max-content" }}
                rowKey="id"
                size="middle"
                className="custom-table user-tbl"
              />
              :
              <Table
                columns={columns}
                dataSource={selectedRebateData}
                loading={loading}
                bordered
                pagination={false}
                scroll={{ x: "max-content" }}
                rowKey="id"
                size="middle"
                className="custom-table user-tbl"
              />
             }
            </>
          )}

          {activeTab === "Audit Logs" && (
            <div className="p-4 text-gray-600">
              Audit Logs content will appear here.
            </div>
          )}

          {activeTab === "Reports" && (
            <div className="p-4 text-gray-600">
              Reports content will appear here.
            </div>
          )}
        </Card>
      </Layout>
    </div>
  );
};

export default AuditLogs;



 {/* <div className="flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 mb-4">
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 w-full md:w-auto">
                  <Select
                    // mode="multiple"
                    value={fileType}
                    onChange={updateFileType}
                    className="w-full md:w-[350px] "
                    style={{
                      // width: "400px",
                      border: "1px solid #d9d9d9",
                      "border-radius": "6px",
                    }}
                    placeholder="Select FileType"
                    options={list?.map((file) => ({
                      label: file.name,
                      value: file.name,
                      key: file.id,
                    }))}
                    // showSearch
                    // filterOption={(input, option) => {
                    //   const label = (option?.label ?? "").toString().toLowerCase();
                    //   const value = (option?.value ?? "").toString().toLowerCase();
                    //   return (
                    //     label.includes(input.toLowerCase()) ||
                    //     value.includes(input.toLowerCase())
                    //   );
                    // }
                    // }
                    maxTagCount={3}
                  />
                </div>
                <div className="flex md:m-0 w-full">
                  <div className="flex gap-1 w-full md:justify-center align-middle justify-start mr-4">
                    <span className="font-medium text-gray-600">From</span>
                    <DatePicker
                      placeholder="From Date"
                      // value={fromDate ? dayjs(fromDate) : null}
                      // onChange={(date) => {
                      //   if (date) {
                      //     const jsDate = new Date(date.toDate());
                      //     jsDate.setHours(0, 0, 0, 0);
                      //     setFromDate(jsDate);
                      //   }
                      // }}
                      format="MM-DD-YYYY"
                      className="w-full "
                    />
                  </div>
                  <div className="flex flex-row w-full gap-1 justify-center align-middle">
                    <span className=" font-medium text-gray-600">To</span>

                    <DatePicker
                      placeholder="To Date"
                      // value={toDate ? dayjs(toDate) : null}
                      // onChange={(date) => {
                      //   if (date) {
                      //     const jsDate = new Date(date.toDate());
                      //     jsDate.setHours(23, 59, 59, 999);
                      //     setToDate(jsDate);
                      //   }
                      // }}
                      format="MM-DD-YYYY"
                      className="w-full "
                    />
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2 w-full  md:w-auto">
                  <div className="gap-2 flex flex-row md:justify-between justify-start w-full md:w-auto">
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      // onClick={handleExport}
                      className="w-full md:w-[200px]  md:mt-0"
                    >
                      Export Comparison Data
                    </Button>
                  </div>
                </div>
              </div> */}

              {/* <div className="flex items-center mt-3">
                <Checkbox>Date 02.3 range</Checkbox>
              </div> */}
